import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import First from '../menerror/First'

function Main() {
  return (
    <>
        <Header/>
        <Breadcrumb title="Home" subtitle="404 Error"/>
        <First/>
    </>
  )
}

export default Main